<template>
  <TContainer :mobile-full="true">
    <UCarousel v-slot="{ item }" :items="items" :ui="imagesCarousel">
      <UCard
        as="a"
        :ui="carouselCardFiveWithBorder"
        :href="item.url"
        @click="emit('button-click', $event)"
      >
        <TLazyimg
          :sources="{
            url: item.image,
          }"
          :alt="item.title"
          classes-img="object-cover w-full h-full rounded-t-lg group-hover:opacity-80 transition ease-in-out duration-300"
          classes="aspect-w-7 aspect-h-6"
        />
        <template #footer>
          <TText variant="semibold" clamp="clamp1" classes="mb-0">
            {{ item.title }}
          </TText>
        </template>
      </UCard>
    </UCarousel>
  </TContainer>
</template>
<script setup lang="ts">
import { imagesCarousel } from '~/modules/design-system/utils/nuxt-ui-config/components/carousel'
import { carouselCardFiveWithBorder } from '~/modules/design-system/utils/nuxt-ui-config/components/card'

export interface propsInterface {
  items: {
    url: string
    image: string
    title: string
  }[]
}

defineProps<propsInterface>()

const emit = defineEmits(['button-click'])
</script>
